import cn from "classnames";
import React from "react";

const TransparentButton = ({ type, onClick, text, className }) => {
  return (
    <button
      type={type ? type : "button"}
      onClick={onClick ? onClick : () => {}}
      className={cn(
        "min-w-24 box-border text-center bg-white text-baseBlue hover:text-white hover:bg-baseBlue border border-white w-full font-bold py-2 px-4 rounded-lg transition duration-300 cursor-pointer"
      )}
    >
      {text}
    </button>
  );
};

export default TransparentButton;
